<template lang="pug">
  video.full-width(:src="mediaObj.url" :poster="getObjProperty(mediaObj, 'video_thumb')" playsinline=true controls=true
    @ended="ended"
    @pause="pause"
    @play="play"
    @fullscreenchange="fullscreenChange"
    @mosfullscreenchange="fullscreenChange"
    @webkitfullscreenchange="fullscreenChange"
    @msfullscreenchange="fullscreenChange"
    ref="video"
  )
</template>

<script>
  export default {
    name: "mrVideo",

    props: {
      mediaObj: {
        type: Object,
        required: true,
        validator(v) {
          return typeof v === 'object' && typeof v.url === 'string'; 
        }
      }
    },

    inject: ['getObjProperty'],

    methods: {
      ended() {
        this.trackMREvent('Video Completed', {
          videoTitle: this.mediaObj.title, 
          videoSrc: this.mediaObj.url 
        });
      },

      pause() {
        this.trackMREvent('Video Paused', {
          videoTitle: this.mediaObj.title, 
          videoSrc: this.mediaObj.url,
          videoPauseAt: +this.$refs.video.currentTime.toFixed(2),
          videoPercentWatched: +((this.$refs.video.currentTime / this.$refs.video.duration) * 100).toFixed(2)
        });
      },

      play() {
        this.trackMREvent('Video Played', {
          videoTitle: this.mediaObj.title, 
          videoSrc: this.mediaObj.url
        });
      },

      fullscreenChange() {
        if (document.fullscreenElement === this.$refs.video) {
          this.trackMREvent('Video Fullscreen', {
            videoTitle: this.mediaObj.title, 
            videoSrc: this.mediaObj.url
          });
        }
      }
    }
  };
</script>

<style scoped lang="stylus">
</style>